import React from "react";
import CardSection from "../../../components/ui/CardSection";
import ChoiceRow from "../../../components/ui/ChoiceRow";
import { ISaleForm } from "../../../classes/interfaces";

interface DeliveryTypeFormProps {
  hasDelivery: boolean;
  hasPickup: boolean;
  deliveryType: "delivery" | "pickUp";
  setFormValues: React.Dispatch<React.SetStateAction<ISaleForm>>;
}

export default function DeliveryTypeForm({
  hasDelivery,
  hasPickup,
  deliveryType,
  setFormValues,
}: DeliveryTypeFormProps) {
  return (
    <CardSection icon="moto" title="Tipo da Entrega">
      {hasDelivery && (
        <ChoiceRow
          icon="moto"
          title="Delivery"
          sub="O estabelecimento entrega o seu pedido"
          selected={deliveryType === "delivery"}
          onClick={() =>
            setFormValues((previousState: any) => ({
              ...previousState,
              deliveryType: "delivery",
            }))
          }
          last={!hasPickup}
        />
      )}

      {hasPickup && (
        <ChoiceRow
          icon="bag"
          title="Retirar no Local"
          sub="Quero retirar meu pedido no local do estabelecimento"
          selected={deliveryType === "pickUp"}
          onClick={() =>
            setFormValues((previousState: any) => ({
              ...previousState,
              deliveryType: "pickUp",
            }))
          }
          last
        />
      )}
    </CardSection>
  );
}
